module.exports = "/assets/data/04b2b969b78709ef880849a2bf5511e3-SM1.data.json";